import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import { useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setwizardPageNumber,
  setBusinessAddressDetails,
  setwizardPageName,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { updateEntityKycDraftStep, uploadEntityKycDraftFiles } from "../../../Utils/entityKycDraft";
import { YearPicker, MonthPicker, DayPicker } from "react-dropdown-date";
import CustomMultiLineTextArea from "./CustomMultiLineTextArea";
import MultiFileSelector from "./FilePicker";
import { useTranslation } from "react-i18next";

interface Props { }

interface FormData {
  taxID: string;
  desBusinessModel: string;
}

interface UploadedFile {
  filename: string;
  url: string;
}

const BusinessInformationForm: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const email = useSelector((state: RootState) => state.entityAccount.email);
  const entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );
  const [date, setDate] = useState({ year: "", month: "", day: "" });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [monthError, setMonthError] = useState(false);
  const [dayError, setDayError] = useState(false);
  const [yearError, setYearError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [taxIdError, setTaxIdError] = useState(false);
  const [employeeError, setEmployeeError] = useState(false);
  const [validated, setValidated] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState<UploadedFile[]>(props.initialValues?.businessDocuments || []);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [isBusinessDiffName, setIsBusinessDiffName] = useState(props.initialValues?.isBusinessDiffName || "No");
  const [doingBusinessAsName, setDoingBusinessAsName] = useState(props.initialValues?.doingBusinessAsName || "");
  const [dbaError, setDbaError] = useState(false);
  const [bussinessDescription, setBussinessDescription] = useState(props.initialValues?.desBusinessModel);
  const [numberOfEmployees, setNumberOfEmployees] = useState(props.initialValues?.numberOfEmployees || "");
  const { userId } = useParams<{ userId?: string }>();



  useEffect(() => {
    if (props.initialValues) {
      const vals = props.initialValues;

      if (vals.businessDateOfFormation) {
        const parts = vals.businessDateOfFormation.split("/");
        if (parts.length === 3) {
          let parsedMonth = parseInt(parts[1], 10);
          let m = parsedMonth > 0 ? (parsedMonth - 1).toString() : "0";
          setDate({ day: parts[0], month: m, year: parts[2] });
        } else if (parts.length === 2 && parts[1].length === 4) {
          setDate((prev: any) => ({ ...prev, month: parts[0], year: parts[1] }));
        }
      }

      if (vals.businessDocuments) setUploadedDocument(vals.businessDocuments);
      if (vals.isBusinessDiffName) setIsBusinessDiffName(vals.isBusinessDiffName);
      if (vals.doingBusinessAsName) setDoingBusinessAsName(vals.doingBusinessAsName);
      if (vals.desBusinessModel) setBussinessDescription(vals.desBusinessModel);
      if (vals.numberOfEmployees) setNumberOfEmployees(vals.numberOfEmployees);
    }
  }, [props.initialValues]);

  useEffect(() => {
    dispatch(setwizardPageName("businessInformation"));
  }, [dispatch]);

  useEffect(() => {
    if (date.year == "" && isSubmitted) {
      setYearError(true);
      return;
    }
  }, [isSubmitted]);

  const saveBusinessAddressDetails = async (
    ssoUserID: string,
    email: String,
    isBusinessDiffName: String,
    doingBusinessAsName: String,
    taxID: String,
    desBusinessModel: String,
    businessDocuments: UploadedFile[],
    numberOfEmployees: String,
    businessDateOfFormation: String,
    files?: File[]
  ) => {
    try {
      let updatedDocuments = [...businessDocuments];

      if (files && files.length > 0) {
        const uploadedNewFiles = await uploadEntityKycDraftFiles(ssoUserID, files);
        if (uploadedNewFiles) {
           updatedDocuments = [...updatedDocuments, ...uploadedNewFiles];
        }
      }

      const payload = {
        email,
        isBusinessDiffName,
        doingBusinessAsName,
        taxID,
        desBusinessModel,
        businessDocuments: updatedDocuments,
        numberOfEmployees,
        businessDateOfFormation
      };

      const response = await updateEntityKycDraftStep(ssoUserID, "businessInformation", payload);
      return response;
    } catch (error: any) {
      console.error(error);
      return null;
    }
  };


  const handleRadioChangeBusinessDiffName = (e: any) => {
    setIsBusinessDiffName(e.target.value);
  };

  const validateTaxID = (value: any) => {
    if (!value) {
      return "Tax ID is required";
    }
  };


  const handleSelectNumOfEmpChange = (event: any) => {
    const selectedValue = event.target.value;
    setNumberOfEmployees(selectedValue);
    setEmployeeError(false);
  };
  const submitBusinessInfoForm = async (formValues: FormData) => {
    setIsSubmitted(true);

    const taxID = formValues.taxID;
    const desBusinessModel = bussinessDescription;
    const ssoUserID = userId || ""

    let hasError = false;

    if (isBusinessDiffName === "Yes" && (!doingBusinessAsName || doingBusinessAsName.trim() === "")) {
      setDbaError(true);
      hasError = true;
    }

    if (!taxID || taxID.trim() === "") {
      setTaxIdError(true);
      hasError = true;
    }

    if (date.month == "") {
      setMonthError(true);
      hasError = true;
    }

    if (date.day == "") {
      setDayError(true);
      hasError = true;
    }

    if (date.year == "") {
      setYearError(true);
      hasError = true;
    }

    if (uploadedDocument.length === 0 && pendingFiles.length === 0) {
      setValidated(true);
      hasError = true;
    }

    if (!bussinessDescription || bussinessDescription.trim() === "") {
      setDescriptionError(true);
      hasError = true;
    }

    if (numberOfEmployees == "") {
      setEmployeeError(true);
      hasError = true;
    }

    if (hasError) {
      return;
    }
    let businessDateOfFormation: any;

    if (date.month != "" && date.day != "" && date.year != "") {
      businessDateOfFormation = date.day + "/" + (parseInt(date.month, 10) + 1).toString() + "/" + date.year;
    }
    if (date.month == "" && date.day != "") {
      businessDateOfFormation = date.day + "/" + date.year;
    }
    if (date.day == "" && date.month != "") {
      businessDateOfFormation = date.day + "/" + date.year;
    }

    const businessAddressDetailsObject = {
      isBusinessDiffName: isBusinessDiffName,
      doingBusinessAsName: doingBusinessAsName,
      taxID: taxID,
      desBusinessModel: desBusinessModel,
      businessDocuments: uploadedDocument,
      numberOfEmployees: numberOfEmployees,
      businessDateOfFormation: businessDateOfFormation,
    };
    dispatch(setBusinessAddressDetails(businessAddressDetailsObject));
    const Response = await saveBusinessAddressDetails(
      ssoUserID,
      email,
      isBusinessDiffName,
      doingBusinessAsName,
      taxID,
      desBusinessModel,
      uploadedDocument,
      numberOfEmployees,
      businessDateOfFormation,
      pendingFiles
    );
    if (Response) {
      dispatch(setwizardPageName("businessPhysicalAddress"));
      dispatch(setwizardPageNumber(6));
      localStorage.setItem('pageName', "businessPhysicalAddress");
      localStorage.setItem('pageNumber', '6');
    }
  };

return (
  <>
    <div className="pt-0 pb-3 mb-5 col-md-11 mx-auto px-2">
      <div className="row justify-content-center">
        <Col md={11}>
          <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
          <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p>
          <h4 className="mt-3 ">{t('kyc.business_address')}</h4>
          <p className="text-secondary small ">
            {t('kyc.business_info_desc')}
          </p>
        </Col>
      </div>
      <div className="row justify-content-center">
        <Col md={11}>
          <Form
            noValidate={true}
            onSubmit={handleSubmit(submitBusinessInfoForm)}
          >
            <p className=" fw-bold">
              {t('kyc.diff_name_q')}
            </p>
            <div className="d-inline-block">
              <input
                type="radio"
                id="radio1"
                name="radioGroup"
                value="Yes"
                checked={isBusinessDiffName === "Yes"}
                onChange={handleRadioChangeBusinessDiffName}
              />
              <label className="form-check-label text-secondary ms-2">
                {t('common.yes')}
              </label>
            </div>
            <div className="form-check d-inline-block mx-4">
              <input
                type="radio"
                id="radio2"
                name="radioGroup"
                value="No"
                checked={isBusinessDiffName === "No"}
                onChange={handleRadioChangeBusinessDiffName}
              />
              <label className="form-check-label text-secondary ms-2">
                {t('common.no')}
              </label>
            </div>

            {isBusinessDiffName === "Yes" && (
              <div className="mb-3 mt-4 row">
                <div className="col-md-6">
                  <label className="form-label  fw-bold">
                    Doing Business As Name
                  </label>
                  <input
                    name="doingBusinessAsName"
                    type="text"
                    className="form-control rounded-5 py-3"
                    placeholder="Enter DBA name"
                    value={doingBusinessAsName}
                    onChange={(e) => {
                      setDoingBusinessAsName(e.target.value);
                      setDbaError(false);
                    }}
                  />
                  {dbaError && (
                    <p className="text-danger fw-bold small text-start ps-2">
                      Doing Business As Name is required
                    </p>
                  )}
                </div>
              </div>
            )}

            <div className="mb-3 mt-4 row">
              <div className="col-md-6">
                <label className="form-label  fw-bold">
                  {t('kyc.tax_id_label')}
                </label>

                <Field
                  name="taxID"
                  type="text"
                  component={renderField}
                  className="form-control rounded-5 py-3"
                  placeholder={t('kyc.tax_id_ph')}
                  id="taxID"
                  onChange={() => setTaxIdError(false)}
                />
                {taxIdError && (
                  <p className="text-danger fw-bold small text-start ps-2">
                    {t('kyc.tax_id_required')}
                  </p>
                )}
              </div>
            </div>

            <div className="mb-3 mt-4 row">
              <label className="form-label  fw-bold">
                {t('kyc.date_of_formation')}
              </label>

              <div className="col-md-4 mb-3 mb-md-0">
                <MonthPicker
                  defaultValue={t('kyc.select_month')}
                  numeric
                  endYearGiven
                  year={parseInt(date.year, 10)}
                  value={parseInt(date.month, 10)}
                  onChange={(month: any) => {
                    setDate((prev) => ({ ...prev, month }));
                    setMonthError(false);
                  }}
                  id={"month"}
                  classes="dropdown form-control form-select rounded-5 px-3 py-2"
                  optionClasses={"option"}
                />
                  <div className={monthError ? "" : "d-none"}>
                    <p className="text-danger fw-bold small text-start ps-2">
                      {t('kyc.select_month_error')}
                    </p>
                  </div>
                </div>

              <div className="col-md-4 mb-3 mb-md-0">
                <DayPicker
                  defaultValue={t('kyc.select_date')}
                  year={new Date().getFullYear()}
                  month={parseInt(date.month, 10)}
                  endYearGiven
                  value={parseInt(date.day, 10)}
                  onChange={(day: any) => {
                    setDate((prev) => ({ ...prev, day }));
                    setDayError(false);
                  }}
                  id={"day"}
                  classes="dropdown form-control form-select rounded-5 px-3 py-2"
                  optionClasses={"option"}
                />
                  <div className={dayError ? "" : "d-none"}>
                    <p className="text-danger fw-bold small text-start ps-2">
                      {t('kyc.select_day_error')}
                    </p>
                  </div>
                </div>
              <div className="col-md-4 mb-3 mb-md-0">
                <YearPicker
                  defaultValue={t('kyc.select_year')}
                  start={1990}
                  end={new Date().getFullYear()}
                  reverse
                  value={parseInt(date.year, 10)}
                  onChange={(year: any) => {
                    setDate((prev) => ({ ...prev, year }));
                    setYearError(false);
                  }}
                  id={"year"}
                  classes="dropdown form-control form-select rounded-5 px-3 py-2"
                  optionClasses={"option"}
                />
                <div className={yearError ? "" : "d-none"}>
                  <p className="text-danger fw-bold small text-start ps-2">
                    {t('kyc.select_year_error')}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label className="form-label  fw-bold">
                {t('kyc.org_docs')}
              </label>
              <p className="text-secondary small">
                {t('kyc.org_docs_desc')}
              </p>
              <p className="  mt-3 fw-bold">
                {t('kyc.org_docs_provide')}
              </p>
              <ul className="p-0 border-0 bg-transparent text-secondary fw-bold small">
                <li className="list-group-item border-0 bg-transparent">
                  {t('kyc.org_docs_articles_inc')}
                </li>
                <li className="list-group-item border-0 bg-transparent ">
                  {t('kyc.org_docs_articles_assoc')}
                </li>
                <li className="list-group-item border-0 bg-transparent">
                  {t('kyc.org_docs_trust')}
                </li>
              </ul>

              <div className="row text-center">
                <div className="col-md-12" >

                  <Col md={12} className="pb-1">
                    <MultiFileSelector
                      maxFiles={6}
                      maxFileSizeMB={20}
                      existedFiles={uploadedDocument}
                      onFilesChange={(files) => {
                        setUploadedDocument(files)
                      }}
                      onPendingFilesChange={(files) => {
                        setPendingFiles(files)
                        if (files.length > 0) setValidated(false);
                      }}
                    />
                  </Col>

                </div>
                {validated && (
                  <p className="text-danger fw-bold small text-start">
                    {t('kyc.upload_doc_required')}
                  </p>
                )}
              </div>

              <Row className="mt-4">
                <label className="form-label  fw-bold">
                  {t('kyc.business_desc_label')}
                </label>
                <p className="text-secondary small ">
                  {t('kyc.business_desc_hint')}
                </p>

                <Row>
                  <CustomMultiLineTextArea
                    initialValue={props?.initialValues?.desBusinessModel || ""}
                    maxWords={2000}
                    onChange={(val) => {
                      setBussinessDescription(val);
                      setDescriptionError(false);
                    }}
                    description={t('kyc.business_desc_ph')}
                  />
                  {descriptionError && (
                    <p className="text-danger fw-bold small text-start">
                    {t('kyc.description_required')}
                  </p>
                  )}
                </Row>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <label className="form-label  fw-bold">
                    {t('kyc.num_employees')}
                  </label>
                  <select
                    className="form-control form-select rounded-5 px-3 py-2"
                    onChange={handleSelectNumOfEmpChange}
                    value={numberOfEmployees}
                  >
                    <option value="">{t('kyc.select_range')}</option>
                    <option>10-100</option>
                    <option>101-500</option>
                    <option>501-1000</option>
                    <option>1001-1500</option>
                    <option>1500+</option>
                  </select>
                  {employeeError && (
                    <p className="text-danger fw-bold small text-start ps-2">
                      {t('kyc.selection_required')}
                    </p>
                  )}
                </Col>
              </Row>
              <Row className="mt-3 mb-1">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="btn btn-primary rounded-5  mt-2 border-0"
                    style={{ background: "#0B1628" }}
                  >
                    {t('common.save_continue')}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Col>
      </div>
    </div>
  </>
);
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    isBusinessDiffName: state.entityAccount.businessAddressDetails.isBusinessDiffName || "",
    taxID: state.entityAccount.businessAddressDetails.taxID || "",
    desBusinessModel: state.entityAccount.businessAddressDetails.desBusinessModel || "",
    businessDocuments: state.entityAccount.businessAddressDetails.businessDocuments || "",
    numberOfEmployees: state.entityAccount.businessAddressDetails.numberOfEmployees || "",
    businessDateOfFormation: state.entityAccount.businessAddressDetails.businessDateOfFormation || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "wizardBusinessinfo",
  enableReinitialize: true,
})(BusinessInformationForm);

export default connect(mapStateToProps)(form);
